module.exports = __webpack_public_path__ + "media/images/bg_event_popup-370ee23131e6a7c8f157265871b065fe.jpg";